const Errors = [
  {
    'code': '1'
  }, {
    'code': '2'
  }, {
    'code': '3'
  }, {
    'code': '4'
  }, {
    'code': '5'
  }, {
    'code': '6'
  }, {
    'code': '7'
  }, {
    'code': '301'
  }, {
    'code': '302'
  }, {
    'code': '303'
  }, {
    'code': '304'
  }, {
    'code': '601'
  }, {
    'code': '602'
  }, {
    'code': '603'
  }, {
    'code': '901'
  }, {
    'code': '902'
  }, {
    'code': '903'
  }, {
    'code': '904'
  }, {
    'code': '905'
  }, {
    'code': '906'
  }, {
    'code': '1001'
  }, {
    'code': '1002'
  }, {
    'code': '1101'
  }, {
    'code': '1201'
  }, {
    'code': '1202'
  }, {
    'code': '1203'
  }, {
    'code': '1204'
  }, {
    'code': '1205'
  }, {
    'code': '1206'
  }, {
    'code': '1207'
  }, {
    'code': '1208'
  }, {
    'code': '1209'
  }, {
    'code': '1210'
  }, {
    'code': '1211'
  }, {
    'code': '1212'
  }, {
    'code': '1501'
  }, {
    'code': '1502'
  }, {
    'code': '1503'
  }, {
    'code': '1504'
  }, {
    'code': '1505'
  }, {
    'code': '1801'
  }, {
    'code': '1802'
  }, {
    'code': '1803'
  }, {
    'code': '1804'
  }, {
    'code': '1805'
  }, {
    'code': '1806'
  }, {
    'code': '1807'
  }, {
    'code': '1808'
  }, {
    'code': '1809'
  }, {
    'code': '2101'
  }, {
    'code': '2401'
  }, {
    'code': '2701'
  }, {
    'code': '2702'
  }, {
    'code': '3001'
  }, {
    'code': '3002'
  }, {
    'code': '3301'
  }, {
    'code': '3302'
  }, {
    'code': '3303'
  }, {
    'code': '3304'
  }, {
    'code': '3401'
  }, {
    'code': '3402'
  }, {
    'code': '3403'
  }, {
    'code': '3404'
  }, {
    'code': '3405'
  }, {
    'code': '3406'
  }, {
    'code': '3407'
  }, {
    'code': '3408'
  }, {
    'code': '3601'
  }, {
    'code': '3602'
  }, {
    'code': '3603'
  }, {
    'code': '3604'
  }, {
    'code': '3801'
  }, {
    'code': '3802'
  }, {
    'code': '3803'
  }, {
    'code': '3804'
  }, {
    'code': '4001'
  }, {
    'code': '4101'
  }, {
    'code': '4201'
  }, {
    'code': '4202'
  }, {
    'code': '4203'
  }, {
    'code': '4204'
  }, {
    'code': '4205'
  }, {
    'code': '4206'
  }, {
    'code': '4207'
  }, {
    'code': '4208'
  }, {
    'code': '4209'
  }, {
    'code': '4501'
  }, {
    'code': '4502'
  }, {
    'code': '4503'
  }, {
    'code': '4504'
  }, {
    'code': '4505'
  }, {
    'code': '4801'
  }, {
    'code': '5101'
  }, {
    'code': '5103'
  }, {
    'code': '5104'
  }, {
    'code': '5105'
  }, {
    'code': '5106'
  }, {
    'code': '5107'
  }, {
    'code': '5108'
  }, {
    'code': '5109'
  }, {
    'code': '5110'
  }, {
    'code': '5111'
  }, {
    'code': '5112'
  }, {
    'code': '5113'
  }, {
    'code': '5114'
  }, {
    'code': '5115'
  }, {
    'code': '5116'
  }, {
    'code': '5117'
  }, {
    'code': '5118'
  }, {
    'code': '5119'
  }, {
    'code': '5120'
  }, {
    'code': '5121'
  }, {
    'code': '5122'
  }, {
    'code': '5123'
  }, {
    'code': '5124'
  }, {
    'code': '5125'
  }, {
    'code': '5128'
  }, {
    'code': '5129'
  }, {
    'code': '5130'
  }, {
    'code': '5131'
  }, {
    'code': '5132'
  }, {
    'code': '5133'
  }, {
    'code': '5134'
  }, {
    'code': '5135'
  }, {
    'code': '5401'
  }, {
    'code': '5402'
  }
]

export { Errors }



// WEBPACK FOOTER //
// ./src/help/ErrorConfig.js